import React from "react";
import { activityBaseInfoItem, GroupListItem } from "../../../service/group";
import { atom } from "jotai";

export const FlagAtom = atom("add");

interface GroupProps {
    groupList: GroupListItem[] | null; //小组列表
}

export const GroupContext = React.createContext<GroupProps>({
    groupList: []
});

//是否修改touched form表单
export const TouchedAtom = atom(false);

//是否显示二次确认的弹窗
export const ShowConfirmAtom = atom(false);

//第一步formData
export const StepOneFormDataAtom = atom<activityBaseInfoItem | undefined>(
    undefined
);

//空form
export const emptyFormAtom = atom(false);

//活动id
export const ActivityIdAtom = atom(-1);

//prev:上一步, next：下一步, waitPrev:等待跳转到上一步,  waitNext:等待跳转到下一步， close：关闭弹窗
export const StepStateAtom = atom<
    "waitPrev" | "prev" | "current" | "next" | "waitNext" | "close"
>("current");

//next：下一步, nextTwoStep， close：关闭弹窗
export const StepOneStateAtom = atom<
    "current" | "next" | "nextTwoStep" | "close"
>("current");

export const PreviewAtom = atom(false); //仅查看
